'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var errCode = require('err-code');

var _require = require('buffer'),
    Buffer = _require.Buffer; // make sure the content only emits buffer-a-likes


function validateChunks(_x) {
  return _validateChunks.apply(this, arguments);
}

function _validateChunks() {
  _validateChunks = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, content;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 2;
            _iterator = _asyncIterator(source);

          case 4:
            _context.next = 6;
            return _awaitAsyncGenerator(_iterator.next());

          case 6:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 10;
            return _awaitAsyncGenerator(_step.value);

          case 10:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 30;
              break;
            }

            content = _value;

            if (!(content.length === undefined)) {
              _context.next = 15;
              break;
            }

            throw errCode(new Error('Content was invalid'), 'ERR_INVALID_CONTENT');

          case 15:
            if (!(typeof content === 'string' || content instanceof String)) {
              _context.next = 20;
              break;
            }

            _context.next = 18;
            return Buffer.from(content, 'utf8');

          case 18:
            _context.next = 27;
            break;

          case 20:
            if (!Array.isArray(content)) {
              _context.next = 25;
              break;
            }

            _context.next = 23;
            return Buffer.from(content);

          case 23:
            _context.next = 27;
            break;

          case 25:
            _context.next = 27;
            return content;

          case 27:
            _iteratorNormalCompletion = true;
            _context.next = 4;
            break;

          case 30:
            _context.next = 36;
            break;

          case 32:
            _context.prev = 32;
            _context.t0 = _context["catch"](2);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 36:
            _context.prev = 36;
            _context.prev = 37;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 41;
              break;
            }

            _context.next = 41;
            return _awaitAsyncGenerator(_iterator.return());

          case 41:
            _context.prev = 41;

            if (!_didIteratorError) {
              _context.next = 44;
              break;
            }

            throw _iteratorError;

          case 44:
            return _context.finish(41);

          case 45:
            return _context.finish(36);

          case 46:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 32, 36, 46], [37,, 41, 45]]);
  }));
  return _validateChunks.apply(this, arguments);
}

module.exports = validateChunks;